import { Link } from 'react-router-dom';

interface ConsultantCardProps {
  name: string;
  role: string;
  specialisation: string;
  bio: string;
  expertise: string[];
  image: string;
  compact?: boolean;
}

export default function ConsultantCard({ name, role, specialisation, bio, expertise, image, compact = false }: ConsultantCardProps) {
  return (
    <article className="group flex flex-col bg-background-100 h-full">
      <div className="w-full aspect-[4/5] overflow-hidden bg-background-200">
        <img
          src={image}
          alt={`${name}, ${role} at Morrow People`}
          title={`${name} — ${specialisation}`}
          className="w-full h-full object-cover object-top media-zoom"
        />
      </div>
      <div className="flex flex-col flex-1 p-5 md:p-7">
        {compact ? (
          <>
            <div className="border-b border-foreground-950/15 pb-4">
              <h3 className="font-heading text-[24px] md:text-[26px] leading-tight text-foreground-950 transition-colors duration-300 ease-ui group-hover:text-accent-600">{name}</h3>
              <p className="mt-1.5 font-label text-[13px] text-foreground-600">{role}</p>
            </div>
            <p className="mt-4 text-[14px] text-accent-600">{specialisation}</p>
            <p className="mt-1.5 text-[14px] leading-[1.6] text-foreground-700">{expertise.join(' · ')}</p>
          </>
        ) : (
          <>
        <div className="flex items-baseline justify-between gap-4 border-b border-foreground-950/15 pb-4">
          <h3 className="font-heading text-[24px] md:text-[26px] leading-tight text-foreground-950">{name}</h3>
          <span className="font-label text-[12px] text-foreground-600 whitespace-nowrap">{role}</span>
        </div>
        <dl className="mt-4 grid grid-cols-[96px_1fr] gap-y-2 text-[13px]">
          <dt className="font-label uppercase tracking-[0.12em] text-foreground-500">Practice</dt>
          <dd className="text-accent-600">{specialisation}</dd>
          <dt className="font-label uppercase tracking-[0.12em] text-foreground-500">Focus</dt>
          <dd className="text-foreground-800">{expertise.join(' · ')}</dd>
        </dl>
        <p className="mt-5 text-[15px] leading-[1.6] text-foreground-700">{bio}</p>
          </>
        )}
        <div className="mt-auto pt-6">
          <Link
            to="/contact"
            className="inline-flex items-center gap-1 text-[14px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 hover:text-accent-600 hover:border-accent-500 transition-colors duration-200 ease-ui focus-ring whitespace-nowrap cursor-pointer"
          >
            Contact {name.split(' ')[0]} <i className="ri-arrow-right-up-line arrow-nudge"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}